import { memo } from "react";
import PixeonPacs from "../PixeonPacs/PixeonPacs";
import VueMotionPacs from "../VueMotionPacs/VueMotionPacs";
import { IExamsWithPacsValidation } from "./models";

interface IExamPacsActionProps {
  exam: IExamsWithPacsValidation;
  hasVueMotionExtension: boolean;
  hasPixeonExtension: boolean;
}

const ExamPacsAction: React.FC<IExamPacsActionProps> = ({
  exam,
  hasVueMotionExtension,
  hasPixeonExtension,
}) => {
  if (!exam.canShowPixeon && !exam.canShowVueMotion) return <>-</>;

  return (
    <>
      {hasVueMotionExtension && exam.canShowVueMotion && (
        <VueMotionPacs dicomAccesses={exam.dicomAccesses} />
      )}
      {hasPixeonExtension && exam.canShowPixeon && (
        <PixeonPacs dicomAccesses={exam.dicomAccesses} />
      )}
    </>
  );
};

export default memo(ExamPacsAction);
